import { CheckIcon, CopyIcon } from 'lucide-react'
import { type ReactNode, useCallback, useState } from 'react'

import { Button } from '@/components/ui/button'

export interface ContentBriefCopyButtonProps {
  onCopy: () => void
}

const COPY_FEEDBACK_DURATION_MS = 2000

export const ContentBriefCopyButton: React.FC<ContentBriefCopyButtonProps> = ({
  onCopy,
}): ReactNode => {
  const [isCopied, setIsCopied] = useState(false)

  const handleCopy = useCallback(() => {
    onCopy()
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), COPY_FEEDBACK_DURATION_MS)
  }, [onCopy])

  return (
    <Button variant="outline" size="sm" onClick={handleCopy} className="content-brief-copy-button">
      {isCopied ? (
        <>
          <CheckIcon className="size-4 text-green-500" />
          Copied
        </>
      ) : (
        <>
          <CopyIcon className="size-4" />
          Copy
        </>
      )}
    </Button>
  )
}
